<template>
  <b-card no-body class="shadow grid-stack-item-content measure-tool mb-2 flex-container">
    <div slot="header">
      <window-header cmp-title="Measure Tool" widget-name="measure"></window-header>
    </div>
    <b-container class="w-100 pl-2 pr-2" :style="{'flex': 3, 'overflow': 'auto'}">
      <table class="table table table-xs table-hover">
        <thead>
        <tr>
          <th class="measurementNumber">#</th>
          <th class="measurementData">Measurement</th>
          <th class="measurementMetric">Metric</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in drawnFeatures">
          <td>{{i}}</td>
          <td>{{item.value}}</td>
          <td v-html="item.units"></td>
        </tr>
        </tbody>
      </table>
    </b-container>

    <b-row class="m-1 d-flex justify-content-between">
      <div class="d-flex justify-content-between">
        <b-form-radio-group v-model="defaultOption" :options="options"></b-form-radio-group>
        <b-button @click.stop.prevent="clearFeatures" size="sm" variant="outline-success" class="btn-xs">Clear all</b-button>
      </div>
    </b-row>
    <window-footer></window-footer>
  </b-card>

</template>

<script>
  import VectorSource from 'ol/source/Vector'
  import VectorLayer from 'ol/layer/Vector'
  import Stroke from 'ol/style/Stroke'
  import Fill from 'ol/style/Fill'
  import Style from 'ol/style/Style'
  import Draw from 'ol/interaction/Draw'
  import LineString from 'ol/geom/LineString'
  import proj4 from 'proj4'
  import Projection from 'ol/proj/Projection'
  import * as olProj from 'ol/proj'
  import Sphere from 'ol/sphere'
  import {unByKey} from 'ol/Observable'
  import { EPSG_28355, EPSG_28356 } from '../../util/projections'
  import { transformGeometry } from '../../util/map'
  import round from 'lodash-es/round'
  import WindowHeader from '../common/WindowHeader'
  import WindowFooter from '../common/WindowFooter'
  import 'vue-awesome/icons/toggle-on'

  proj4.defs('EPSG:28356', EPSG_28356)
  proj4.defs('EPSG:28355', EPSG_28355)
  olProj.addProjection(new Projection({
    code: 'EPSG:28356'
  }))
  olProj.addProjection(new Projection({
    code: 'EPSG:28355'
  }))


  export default {
    name: 'measure-tool',
    components: {WindowHeader, WindowFooter},
    computed: {

    },
    created () {
      this.source = new VectorSource()
      this.layer = new VectorLayer({
        source: this.source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(204, 0, 0, 0.3)'
          }),
          stroke: new Stroke({
            color: 'rgba(204, 0, 0, 0.8)',
            width: 2
          })
        }),
        zIndex: 1000
      })

      this.draw = null
    },
    mounted () {
      this.initClick()
    },
    destroyed () {
      this.unInitClick()
    },
    watch: {
      defaultOption (val) {
        // Interaction via map service was not being updated on watch
        // changes made below
        this.unInitClick()
        this.initClick()
      }
    },
    methods: {
      clearFeatures () {
        this.drawnFeatures = []
        this.source.clear()
      },
      initClick () {
        this.$mapService.map.addLayer(this.layer)
        this.$mapService.addInteraction(this.getDrawInteraction())
      },
      unInitClick () {
        this.$mapService.map.removeLayer(this.layer)
        this.$mapService.removeInteraction(this.draw)
      },
      getDrawInteraction () {
        this.draw = new Draw({
          source: this.source,
          type: this.defaultOption
        })
        this.draw.on('drawstart', this.onDrawStart, this)
        this.draw.on('drawend', this.onDrawEnd, this)
        return this.draw
      },
      onDrawStart(e) {
        // set sketch
        var me = this
        me.sketch = e.feature;
        var index = this.drawnFeatures.length + 1
        let value

        me.listener = me.sketch.getGeometry().on('change', function(evt) {
          if (!me.drawnFeatures[index - 1]) {
            return
          }
          var geom = transformGeometry(evt.target.clone(), 'EPSG:3857', me.$store.getters['project/currentProject'].workpack.best_srid || 'EPSG:28356')
          if (geom instanceof LineString) {
            me.currentDrawLength = round(geom.getLength(), 2)
            me.drawnFeatures[index - 1].value = me.currentDrawLength
            me.drawnFeatures[index - 1].units = 'm'
          } else {
            me.currentDrawLength = round(geom.getArea(), 2)
            me.drawnFeatures[index - 1].value = me.currentDrawLength
            me.drawnFeatures[index - 1].units = 'm<sup>2</sup>'
          }
        })
        this.drawnFeatures.push({
          index: index,
          value: this.currentDrawLength,
          units: ''
        })
      },
      onDrawEnd (e) {
        // unset drawing vars
        this.sketch = null;
        this.currentDrawLength = 0;
        unByKey(this.listener);
        this.listener = null
      },
    },
    data () {
      return {
        fields: {
          index: {
            label: '#'
          },
          value: {
            label: 'Value'
          },
          units: {
            label: 'Units'
          }
        },
        currentDrawLength: 0,
        sketch: null,
        listener: null,
        drawnFeatures: [],
        defaultOption: 'LineString',
        options: [
          {
            text: 'Length',
            value: 'LineString'
          },
          {
            text: 'Area',
            value: 'Polygon'
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/MeasureTool.vue